import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RoutesPaths } from "../Router/constant";

function Esg() {
  const { t } = useTranslation();
  const heroPillars = t("pages.esg.hero.pillars", { returnObjects: true });
  const stats = t("pages.esg.stats", { returnObjects: true });
  const environmentalItems = t("pages.esg.environmental.items", {
    returnObjects: true,
  });
  const socialItems = t("pages.esg.social.items", { returnObjects: true });
  const governanceItems = t("pages.esg.governance.items", {
    returnObjects: true,
  });

  const environmentalIcons = [
    "/images/esg-environmental-icon.svg",
    "/images/esg-responsible-icon.svg",
    "/images/esg-capital-icon.svg",
  ];
  const socialIcons = [
    "/images/esg-users-icon.svg",
    "/images/esg-home-icon.svg",
    "/images/esg-world-icon.svg",
  ];
  const governanceIcons = [
    "/images/governance-transparency-icon.svg",
    "/images/governance-compliance-icon.svg",
    "/images/governance-accountability-icon.svg",
  ];

  useEffect(() => {
    const elements = document.querySelectorAll(".reveal-on-scroll");

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = entry.target.dataset.delay;
            if (delay) {
              entry.target.style.transitionDelay = `${delay}ms`;
            }

            entry.target.classList.add("show");
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="esg-page">
      <section className="esg-hero">
        <div className="main-container esg-hero__content">
          <div className="esg-hero__inner">
            <h1 className="m-0 fw-bold f-s-48 l-h-60 reveal-on-scroll fade-up">
              {t("pages.esg.hero.title")}
            </h1>
            <p className="m-0 esg-hero__text f-s-20 l-h-30 reveal-on-scroll fade-up" data-delay="150">
              {t("pages.esg.hero.text")}
            </p>

            {/* <div className="esg-hero__chips" aria-label={t("pages.esg.hero.pillarsLabel")}>
              {heroPillars.map((pillar) => (
                <span className="esg-hero__chip reveal-on-scroll fade-up" key={pillar.key} data-delay="300">
                  <strong>{pillar.key}</strong>
                  <small>{pillar.label}</small>
                </span>
              ))}
            </div> */}
          </div>
        </div>
      </section>

      <section className="about-stats">
        <div className="main-container">
          <div className="row g-0">
            {stats.map((item, index) => (
              <div
                className={`col-lg col-md-4 col-6${
                  stats.length % 2 !== 0 && index === stats.length - 1
                    ? " about-stats__col--center-mobile"
                    : ""
                }`}
                key={item.label}
              >
                <div className="about-stat">
                  <h2 className="m-0 f-w-700 c-s-w reveal-on-scroll fade-left">{item.value}</h2>
                  <p className="m-0 f-s-16 l-h-28 c-s-w reveal-on-scroll fade-right" data-delay="450">
                    {item.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="esg-intro">
        <div className="main-container">
          <div className="row g-5 align-items-center">
            <div className="col-md-12 text-center">
              {/* <span className="esg-kicker reveal-on-scroll fade-left" data-delay="150">
                {t("pages.esg.intro.kicker")}
              </span> */}
              <h2 className="m-0 esg-intro__title f-s-36 l-h-48 reveal-on-scroll fade-left" data-delay="200">
                {t("pages.esg.intro.title")}
              </h2>
              <p className="m-0 mb-3 esg-intro__caption reveal-on-scroll fade-left" data-delay="250">
                {t("pages.esg.intro.caption")}
              </p>
              <p className="m-0 esg-intro__caption reveal-on-scroll fade-left" data-delay="250">
                {t("pages.esg.intro.caption1")}
              </p>
            </div>

            {/* <div className="col-lg-6">
              <div className="esg-intro__copy">
                {introParagraphs.map((paragraph, index) => (
                  <p className="m-0 f-s-16 l-h-24 reveal-on-scroll fade-right" data-delay={`${300 + index * 50}`} key={paragraph}>
                    {paragraph}
                  </p>
                ))}
              </div>

              <div className="esg-intro__quote reveal-on-scroll fade-right" data-delay="400">
                {t("pages.esg.intro.quote")}
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <section className="esg-pillar">
        <div className="main-container">
          <div className="esg-section-heading text-center">
            <h2 className="m-0 f-s-48 l-h-60 reveal-on-scroll fade-left">
              {t("pages.esg.environmental.title")}
            </h2>
            <p className="m-0 f-s-20 l-h-30 reveal-on-scroll fade-right" data-delay="150">
              {t("pages.esg.environmental.text")}
            </p>
          </div>

          <div className="row g-4 align-items-center">
            <div className="col-md-6">
              <div className="esg-media-card reveal-on-scroll fade-left" data-delay="300">
                <img src="/images/esgenvironmental.jpg" alt="Environmental landscape" />
                <span className="esg-media-card__label">{t("pages.esg.environmental.badgeLabel")}</span>
                <div className="esg-media-card__badge">
                  <strong>100%</strong>
                  <span>{t("pages.esg.environmental.badgeText")}</span>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="esg-feature-list">
                {environmentalItems.map((item, index) => (
                  <article className="esg-feature-card reveal-on-scroll fade-right" data-delay="350" key={item.title}>
                    <div className="esg-feature-card__icon">
                      <img src={environmentalIcons[index]} alt="" />
                    </div>
                    <div>
                      <h3 className="m-0 f-s-20 l-h-30">{item.title}</h3>
                      <p className="m-0 f-s-16 l-h-24">{item.description}</p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="esg-pillar esg-pillar--social">
        <div className="main-container">
          <div className="esg-section-heading esg-section-heading--light text-center">
            <h2 className="m-0 f-s-48 l-h-60 reveal-on-scroll fade-left">
              {t("pages.esg.social.title")}
            </h2>
            <p className="m-0 f-s-20 l-h-30 reveal-on-scroll fade-right" data-delay="150">
              {t("pages.esg.social.text")}
            </p>
          </div>

          <div className="row g-4 align-items-center">
            <div className="col-md-6 order-2 order-lg-1">
              <div className="esg-feature-list">
                {socialItems.map((item, index) => (
                  <article className="esg-feature-card esg-feature-card--soft reveal-on-scroll fade-left" data-delay="300" key={item.title}>
                    <div className="esg-feature-card__icon">
                      <img src={socialIcons[index]} alt="" />
                    </div>
                    <div>
                      <h3 className="m-0 f-s-20 l-h-30">{item.title}</h3>
                      <p className="m-0 f-s-16 l-h-24">{item.description}</p>
                    </div>
                  </article>
                ))}
              </div>
            </div>

            <div className="col-md-6 order-1 order-lg-2">
              <div className="esg-media-card esg-media-card--social reveal-on-scroll fade-right" data-delay="350">
                <img src="/images/esgcommunity.jpg" className="img-fluid" alt="Social collaboration" />
                <div className="esg-media-card__panel">
                  <span>{t("pages.esg.social.panelLabel")}</span>
                  <strong>{t("pages.esg.social.panelTitle")}</strong>
                  <p className="m-0">{t("pages.esg.social.panelText")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="esg-governance">
        <div className="main-container">
          <div className="esg-section-heading text-center">
            <h2 className="m-0 f-s-48 l-h-60 reveal-on-scroll fade-left">
              {t("pages.esg.governance.title")}
            </h2>
            <p className="m-0 f-s-20 l-h-30 reveal-on-scroll fade-right" data-delay="150">
              {t("pages.esg.governance.text")}
            </p>
          </div>

          <div className="row g-4">
            {governanceItems.map((item, index) => (
              <div className="col-md-4" key={item.title}>
                <article className="esg-governance-card reveal-on-scroll fade-up" data-delay="200">
                  <div className="esg-feature-card__icon">
                    <img src={governanceIcons[index]} alt="" />
                  </div>
                  <h3 className="m-0">{item.title}</h3>
                  <p className="m-0">{item.description}</p>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-stratagic mt-0">
        <div className="main-container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-9 text-center px-3">
              <h2 className="m-0 f-w-600 f-s-48 l-h-60 c-s about-cta__title reveal-on-scroll fade-up">
                {t("common.siteCta.title")}
              </h2>
              <p className="m-0 f-s-20 l-h-30 c-s about-cta__text reveal-on-scroll fade-up" data-delay="150">
                {t("common.siteCta.text")}
              </p>

              <NavLink
                className="contact-btn d-flex align-items-center f-w-600 f-s-14 l-h-100 mx-auto"
                to={RoutesPaths.CONTACT}
              >
                <span className="btn-text">{t("common.cta.contact")}</span>
                <span className="arrow-circle">
                  <img src="/images/right-angle-arrow.png" alt="icon" />
                </span>
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Esg;
